export const GUIDE_STEPS = [
  {
    key: "connect",
    label: "Connect a system",
    hint: "I'll watch it once it's linked — Salesforce, Zoho or Oracle.",
    to: "/dashboard/connections",
    emie: "Walk me through connecting Salesforce.",
  },
  {
    key: "rule",
    label: "Set a governance rule",
    hint: "One threshold is enough. I'll surface breaches on Overview.",
    to: "/dashboard/governance",
    emie: "Help me set a usage threshold I should watch.",
  },
  {
    key: "extraction",
    label: "Run your first extraction",
    hint: "Export a few objects so jobs and EMIE have real data.",
    to: "/dashboard/extraction",
    emie: "What's the simplest first export I should run?",
  },
];

export function nextGuideStep(status) {
  if (!status || status.completed) return null;
  const steps = status.steps || {};
  return GUIDE_STEPS.find((s) => !steps[s.key]) || null;
}

export function refreshGuide() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("gx-guide-refresh"));
  }
}

export function emieSuggestionsFor(pathname, restricted) {
  if (restricted) return [];
  if (pathname.includes("/connections")) {
    return [
      "Walk me through connecting Salesforce.",
      "OAuth or username — which is safer here?",
    ];
  }
  if (pathname.includes("/governance")) {
    return [
      "Help me set a usage threshold I should watch.",
      "What should I do when a limit is close?",
    ];
  }
  if (pathname.includes("/extraction")) {
    return [
      "What's the simplest first export I should run?",
      "Any failed extractions in the last day?",
    ];
  }
  if (pathname.includes("/campaigns")) {
    return [
      "Create a campaign called Q3 Salesforce limits.",
      "List my campaigns.",
    ];
  }
  if (pathname.includes("/team")) {
    return [
      "What can I change in this workspace?",
      "Who has to approve my edits?",
    ];
  }
  if (pathname.includes("/jobs")) {
    return [
      "Should I schedule this or run a one-off first?",
      "Any failed extractions in the last day?",
    ];
  }
  if (pathname.includes("/billing")) {
    return ["When does my trial end, and what happens after?"];
  }
  return [
    "What should I do next in this workspace?",
    "Create a campaign for our Salesforce limits.",
    "Help me set a usage threshold I should watch.",
  ];
}
